import { sendWebsocketMessage } from '../../../../../../App';

export function removeTactic(tradePlanId, tactic, tacticId) {
  const msg = {
    messageType: 'updateTradePlan',
    field: 'removeTactic',
    tradePlanId,
    value: {
      tactic,
      tacticId,
    },
  };
  sendWebsocketMessage(msg);
}
